import { useState, type ReactNode } from 'react'
import { Icon, SignaturePrompt, toastSuccess } from 'admination-react'

export function SignaturePad({
  open,
  title,
  onSubmit,
  onClose,
  hint = "Bitte unterschreiben Sie im Feld unten mit der Maus oder dem Finger.",
  clearLabel = "Löschen",
  cancelLabel = "Schließen",
  confirmLabel = "Übernehmen",
  successMessage,
  secondaryAction,
}: {
  open: boolean

  title: string
  onSubmit: (pngDataUrl: string) => Promise<void> | void
  onClose: () => void

  hint?: ReactNode
  clearLabel?: ReactNode

  cancelLabel?: string
  confirmLabel?: ReactNode

  successMessage?: string | null

  secondaryAction?: ReactNode
}) {
  const [submitting, setSubmitting] = useState(false)

  if (!open) return null

  async function handleCapture(pngDataUrl: string) {

    setSubmitting(true)
    try {
      await onSubmit(pngDataUrl)
      const message = successMessage === undefined ? `${title} erfolgreich signiert.` : successMessage
      if (message) toastSuccess(message)

      setSubmitting(false)
      onClose()
    } catch {

      setSubmitting(false)
    }
  }

  return (
    <SignaturePrompt
      title={title}
      clearLabel={clearLabel}
      cancelLabel={cancelLabel}
      confirmLabel={
        <>
          <Icon name="i-check" />
          {confirmLabel}
        </>
      }
      busy={submitting}
      secondaryAction={secondaryAction}
      onCancel={onClose}
      onCapture={(dataUrl) => void handleCapture(dataUrl)}
    >
      {hint}
    </SignaturePrompt>
  )
}
